import React, { useContext } from 'react';
import MyContext from '~/src/services/context';
import { grantedForRole } from '~/src/utils/misc';

export default function RolesDependent({ children, roles }): JSX.Element {
  const context = useContext(MyContext);
  const permissionGranted = grantedForRole(roles, context.user?.role);
  if (permissionGranted) {
    return <>{children}</>;
  } else {
    return <></>;
  }
}
